// extracted by mini-css-extract-plugin
export default {"title":"DataGrid--title--fUzww","row":"DataGrid--row--kqDUg","grid-item":"DataGrid--grid-item--yTJOI","gridItem":"DataGrid--grid-item--yTJOI"};